import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid, { GridProps } from '@material-ui/core/Grid';

const styles = {
	grid: {
		padding: '0 12px !important',
	},
	disabled: {
		opacity: '0.35',
		'pointer-events': 'none',
	},
};

const useStyles = makeStyles(styles);

interface IGridItemProps extends GridProps {
	className?: string;
	disabled?: boolean;
	children?: string | React.ReactElement | Element[] | React.ReactElement[] | Element;
}

const GridItem = (props: IGridItemProps) => {
	const classes = useStyles();
	const { children, className, disabled, ...rest } = props;

	return (
		<Grid item {...rest} className={classes.grid + ' ' + (disabled ? classes.disabled : '') + ' ' + className}>
			{children}
		</Grid>
	);
};
export default GridItem;
